import { authToken } from "../../utils/helper";
import { baseUrl } from "../../utils/sysEnv";
import * as types from '../types'
import axios from "axios";
import { toast } from "react-toastify";

// GET  Statements
export const getCustomerStatement = info => async (dispatch) => {
    try {
      dispatch({ type: types.SET_STATEMENT_LOADING });
      await axios
        .post(`${baseUrl}/statements`, info, authToken(info.token))
        .then((res) => {
          dispatch({
            type: types.GET_MY_STATEMENT,
            payload: res.data.data,
          });
        })
        .catch((error) => {
            dispatch({ type: types.RESET });
        });
    } catch (err) {
      dispatch({ type: types.RESET });
       toast.error( err.response);
    }
  };



// GET ALL tariffs
export const printStatement = info => async (dispatch) => {
    try {
      dispatch({ type: types.SET_STATEMENT_LOADING });
      await axios
        .post(`${baseUrl}/statements/print`, info, authToken(info.token))
        .then((res) => {
          dispatch({
            type: types.PRINT_MY_STATEMENT,
            payload: res.data.data,
          });
        })
        .catch((error) => {
            dispatch({ type: types.RESET });
        });
    } catch (err) {
      dispatch({ type: types.RESET });
       toast.error( err.response);
    }
  };